
import IdType from './IdType.js';
import UuidType from'./UuidType.js';
import JsonType from'./JsonType.js';
import ArrayType from'./ArrayType.js';
import FloatType from'./FloatType.js';
import IntegerType from'./IntegerType.js';
import DateType from'./DateType.js';
import BooleanType from'./BooleanType.js';
import StringType from'./StringType.js';

// Names exports
export default  {
    Id: IdType,
    Uuid: UuidType,
    Json: JsonType,
    Float: FloatType,
    Number: IntegerType,
    Integer: IntegerType,
    String: StringType,
    Boolean: BooleanType,
    Array: ArrayType,
    Date: DateType
}   
 